import type { inferRouterOutputs } from "@trpc/server";
import type { AppRouter } from "@bookdental/api";

export { formatPriceCents as reais, parsePriceInput as textoParaCentavos } from "@/components/services/service-meta";

type Saidas = inferRouterOutputs<AppRouter>;
export type LancamentoDaLista = Saidas["financeiro"]["lancamentos"]["listar"][number];
export type CategoriaFinanceira = Saidas["financeiro"]["categorias"]["listar"][number];
export type RecorrenciaDaLista = Saidas["financeiro"]["recorrencias"]["listar"][number];
export type ResumoAReceber = Saidas["financeiro"]["aReceber"]["resumo"];
export type ExtratoDoCliente = Saidas["financeiro"]["aReceber"]["extrato"];
export type SerieDaVisao = Saidas["financeiro"]["visao"]["serie"];
export type MesDaVisao = Saidas["financeiro"]["visao"]["mes"];

/** Eixo de gráfico: "R$ 12,5 mil", "R$ 1,2 mi". */
export function reaisCurtos(cents: number): string {
  const v = cents / 100;
  const abs = Math.abs(v);
  const fmt = (n: number) => n.toLocaleString("pt-BR", { maximumFractionDigits: 1 });
  if (abs >= 1_000_000) return `R$ ${fmt(v / 1_000_000)} mi`;
  if (abs >= 1_000) return `R$ ${fmt(v / 1_000)} mil`;
  return `R$ ${fmt(v)}`;
}

export const porcentagem = (p: number | null) => (p == null ? "—" : `${(p * 100).toLocaleString("pt-BR", { maximumFractionDigits: 1 })}%`);
export type NotaDaLista = Saidas["financeiro"]["notas"]["listar"][number];
export type MesDoFechamento = Saidas["financeiro"]["fechamento"]["listar"][number];
export type AFaturar = Saidas["financeiro"]["extratos"]["aFaturar"];
export type DestinatarioAFaturar = AFaturar["destinatarios"][number];
export type ExtratoDaLista = Saidas["financeiro"]["extratos"]["listar"][number];
export type ExtratoAberto = Saidas["financeiro"]["extratos"]["abrir"];
export type PreparoDoEnvio = Saidas["financeiro"]["envio"]["preparar"];
export type ResultadoDoEnvio = Saidas["financeiro"]["envio"]["fecharEEnviar"]["resultados"][number];
